import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { findName, findStorage, findTasks, handleLogout, registerDefaultTaskList } from '../logic/utils';
import InputField from './InputField';
import SingleTodo from './SingleTodo';
const TodoList = ({ webId }) => {
    const [userName, setUserName] = useState('');
    const [taskLocation, setTaskLocation] = useState('');
    const [tasks, setTasks] = useState([]);
    useEffect(() => {
        findTasks(webId, taskLocation)
            .then((tasks) => setTasks(tasks.sort((a, b) => a.title.localeCompare(b.title))))
            .catch(() => alert('Retrieving tasks failed'));
        findName(webId)
            .then((name) => setUserName(name))
            .catch(() => alert('Failed to find username')); // this will never happen because it falls back to WebID
        findStorage(webId)
            .then((storage) => {
            // By default, our base starts from the webId containing folder
            const defaultTaskLocation = (storage != null ? new URL(storage) : new URL('./', webId)).href + 'private/todos/todos';
            setTaskLocation(defaultTaskLocation);
            registerDefaultTaskList(defaultTaskLocation).catch(() => alert('Failed to register default task list'));
        })
            .catch(() => alert('Failed to find storage on WebID')); // this will occur when the logic fails, not the query
    }, [taskLocation]);
    const logoutEventHandler = () => {
        handleLogout().catch(() => alert('Logout failed!'));
    };
    const taskElements = tasks.map((task) => (_jsx("div", { children: _jsx(SingleTodo, { task: task, tasks: tasks, setTasks: setTasks, taskLocation: taskLocation }) }, task.id)));
    return (_jsxs("div", { className: "flex flex-col flex-grow gap-2", children: [_jsxs("div", { className: "flex flex-row gap-4 items-center", children: [_jsxs("p", { children: ["You are logged in as: ", userName, " "] }), _jsx("input", { type: "submit", className: "todo-input-button", value: "Logout", onClick: logoutEventHandler })] }), _jsx(InputField, { tasks: tasks, setTasks: setTasks, taskLocation: taskLocation }), taskElements] }));
};
export default TodoList;
